// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1eZ6U","inputDescription":"styles_inputDescription__c20Un"};